import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionEnrollmentAccountStatus, CommissionEnrollmentNode } from "./types";

export interface CommissionEnrollmentsQueryResponse {
  commissionEnrollments: {
    nodes: CommissionEnrollmentNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionEnrollmentsQueryVariables extends PaginationVariables {
  search?: string;
  accountStatus?: CommissionEnrollmentAccountStatus;
}

export const COMMISSION_ENROLLMENTS_QUERY: TypedDocumentNode<
  CommissionEnrollmentsQueryResponse,
  CommissionEnrollmentsQueryVariables
> = gql`
  query CommissionEnrollments(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $search: String
    $accountStatus: BackofficeCommissionEnrollmentAccountStatus
  ) {
    commissionEnrollments(
      first: $first
      after: $after
      last: $last
      before: $before
      search: $search
      accountStatus: $accountStatus
    ) {
      nodes {
        id
        accountStatus
        person {
          id
          displayName
          pgaId
        }
        program {
          id
          name
          slug
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
